<template>
  <div id="app">
    <router-view />
    <div class="pageCovers" v-if="loadings">
        <van-loading size="50" style="margin-top:40vh" color="white" vertical/> 
    </div>
  </div>
</template>
<script>
export default {
  name: "app",
  data:function() {
    return {
          username: '',
          password: '',
          passwordAg: '',
          phone:'',
          vcode:'',
          topath:'',
    };
  },
  watch:{
	  $route(to,from){
      console.log(to.path);//到哪去
      this.topath=to.path
    }
  },
  mounted:function() {
    var that = this;
    //关闭loading
    //  setTimeout(function(){
    //       that.$store.commit("setLoadings", false);
    //  },3000)
  },
  computed: {
      loadings(){
          return this.$store.getters.loadings;
      }
  },
  methods: {
    onSubmit(values) {
      console.log('submit', values);
    },
     goLogin(){
      this.$router.push({path:'login'});
    },
    goBack(){
      this.$router.push({path:'home'});
    },
  }
};
</script>
<style lang="less">
.fjsc{
        background: white;
        padding-left:17px;
    }
    .fjsc{
      p{
        font-size:15px;
        margin-bottom: 10px;
        position: relative;
        top:5px;
        color: #646566;
        font-size:14px;
      }
    }
    .goback222{
        width:65px;
        height:65px;
        position: fixed;
        z-index: 99999;
        bottom:20px;
        right:20px;
        border-radius:50%;
        background: linear-gradient(137deg,rgba(109,210,253,1) 0%,rgba(28,164,255,1) 100%);
        box-shadow: 1px 2px 6px 0px rgba(104,189,225,1);
        color:white;
        font-size:13px;
    } 
  @import './assets/styles/reset.less';
  @import './assets/styles/common.less';
  .van-hairline--bottom{
    background: #187ef9 !important;
    .van-icon,.van-nav-bar__text,.van-nav-bar__title{
      color:white !important;
      font-weight:normal !important;
    }
  }
  .van-hairline--bottom::after{
    border:none !important;
  }
  .topBar{
    position: fixed !important;
    width:100%;
    z-index: 9999 !important;
  }
  
  .allHeader{
    position: fixed;
    width:100%;
    top:0;
    z-index: 10086;
  }
  .getBuild{
    height: 50px;
  }
  .pageCovers{
    position:fixed;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    top:0;
    z-index: 9998;
  }
  .status {
  float: right;
  margin-right: 10px;
  color: rgb(100, 100, 100);
}
.orderNum {
}
.gdItem {
  background: white;
  padding: 16px 15px;
}
.gdItem:first-child {
}
.orders {
}
.reposition{
}
.point{
  float: left;
  width: 10px;
  height: 10px;
  border-radius:50%;
  background-color:orange;
  margin-top:5px;
  margin-right:5px;
}
.point2{
  float: left;
  width: 10px;
  height: 10px;
  border-radius:50%;
  background-color:green;
  margin-top:5px;
  margin-right:5px;
}
.down{
   background-color:green;
}
</style>
